import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fire",
  "use": "fire-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"fire\">\n    <path d=\"M8.75 11.25c-1.25 1.25-1.25 3.75 0 5-2.176-.54-3.75-2.5-3.75-5 0-3.125 3.125-3.125 2.5-7.5 1.25.01 2.664 1.2 3.125 4.375.484-.451 1.342-1.889 1.25-2.5C14.07 7.194 15 8.75 15 11.25s-1.564 4.412-3.75 5c1.25-1.25 1.25-2.5 0-3.75-.338 1.085-.754 1.504-1.25 1.25-.496-.249-.912-1.084-1.25-2.5z\" fill=\"#fff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol